<div
    *ngIf="customerLanding$ | async; let customerLanding; else: loading"
    class="forget-password-wrapper"
    fxLayout="column"
    fxLayoutAlign="center center"
    [ngStyle]="{ 'background-image': 'url(' + customerLanding.background_url + ')' }"
>
    <div class="layer"></div>
    <mat-card class="forget-password" fxFlex.lt-md="30%">
        <h3 class="title white">
            <span i18n>Forgot your password?</span>
        </h3>
        <mat-card-content>
            <app-form-error
                [messages]="(error | async)?.error.messages"
                [header]="'Password reset failed'"
                i18n-header
            ></app-form-error>
            <app-alert-success
                *ngIf="success"
                header="Email Sent!"
                i18n-header
                message="Please check your email address"
                i18n-message
            >
            </app-alert-success>

            <form [formGroup]="passwdForm" #forgetPasswordForm fxLayout="row wrap" fxLayoutAlign="center">
                <p class="white" fxFlex="0 0 100%" i18n>Send a password reset email.</p>

                <app-academy-select
                    class="academy-select"
                    *ngIf="academies"
                    [academies]="academies"
                    [control]="passwdForm.get('short_name') | cast"
                ></app-academy-select>

                <mat-form-field *ngIf="!academies" fxFlex="1 1 100%" appearance="fill">
                    <mat-label i18n="@@username">Username</mat-label>
                    <input matInput type="email" formControlName="username" name="username" required />
                </mat-form-field>
            </form>
        </mat-card-content>
        <mat-card-actions class="flex">
            <div class="flex-space"></div>
            <button mat-raised-button color="primary" *ngIf="!mailIsSend" type="submit" (click)="onSubmit()" i18n>
                Send email
            </button>
            <div class="space"></div>
            <button class="white" mat-button (click)="login()" *ngIf="!mailIsSend" i18n>Cancel</button>
            <div class="flex-space"></div>
            <button mat-raised-button (click)="login()" color="primary" *ngIf="mailIsSend" i18n>Login</button>
        </mat-card-actions>
    </mat-card>
    <app-footer class="login-footer" [smallFooter]="true" fxFlex="1 1 auto"></app-footer>
</div>
<ng-template #loading>
    <app-kd-logo-loading></app-kd-logo-loading>
</ng-template>
